import { render, staticRenderFns } from "./MyCompanyView.vue?vue&type=template&id=28e18ec3&"
import script from "./MyCompanyView.vue?vue&type=script&lang=js&"
export * from "./MyCompanyView.vue?vue&type=script&lang=js&"
import style0 from "./MyCompanyView.vue?vue&type=style&index=0&id=28e18ec3&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports